import { Address } from './Client';

export enum OrganizationStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
  PENDING = 'pending'
}

export interface OrganizationBranding {
  logoUrl?: string;
  logoFileName?: string;
  logoUpdatedAt?: Date;
}

export interface Organization {
  id: string;
  /** When an org was migrated to clients/{id}, this matches the old organizations/{id}. */
  legacyOrganizationId?: string;
  entityType?: 'client' | 'organization_legacy';
  name: string;
  address: Address;
  status: OrganizationStatus;
  projectIds?: string[];
  clientIds: string[]; // legacy alias
  email?: string;
  phone?: string;
  settings?: OrganizationSettings;
  branding?: OrganizationBranding;
  createdAt: Date;
  updatedAt: Date;
}

export interface OrganizationSettings {
  defaultHourlyRate?: number;
  defaultCurrency?: string;
  taxRate?: number;
  paymentTerms?: number; // Net days
}
